import ModalService from "services/modal";

export const configureAlertsModal = new ModalService();
